const authViewNames = {
  register: 'register',
  login: 'login',
  resetPassword: 'resetPassword',
}


export default authViewNames
